import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { responseObj } from '../nest-model/nest-model';
import { RequestCategory, RequestRoom, RequestCourse, ResponseRoom, ResponseCategory, ResponseVenue, RequestHistory } from '../gd-integrated/dto/training.dto';
import { Observable } from 'rxjs';

/*
  Generated class for the TrainingHistoryApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TrainingHistoryApiProvider {

  module: string = 'training';
  model: string = 'sf6s/training';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider) {
    console.log('Hello TrainingHistoryApiProvider Provider');
  }

  history(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "history";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  historybyId(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "history";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  list(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "list";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  detailAdd(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "detailAdd";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  participant(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "participant";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  filterEmployee(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "filterEmployee";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  category(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "category";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  myTrainingHistory(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "myTrainingHistory";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  feedback(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "feedback";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  evaluation(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "evaluation";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  evaluationStage(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "evaluationStage";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  addFeedback(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "addFeedback";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  saveEvaluation(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "saveEvaluation";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }


  save(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "save";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  delete(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  addCancel(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "addCancel";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  saveCancel(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "saveCancel";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  deleteCancel(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "deleteCancel";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  cancellationHistory(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "cancellationHistory";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  submitEmpAttendance(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "submitEmpAttendance";
    const params: any = formData || {};
    const urlParams: any = formData || {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  activityData(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "activityData";
    const params: any = formData || {};
    const urlParams: any = formData || {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  addWaitingList(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "addWaitingList";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  course(formData: RequestCourse) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "course";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  venue(): Observable<ResponseVenue> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "venue";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseVenue>(method, url, params, urlParams, body, contentType);
  }

  room(formData: RequestRoom): Observable<ResponseRoom> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "room";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseRoom>(method, url, params, urlParams, body, contentType);
  }

  categoryList(formData: RequestCategory): Observable<ResponseCategory> {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "categoryList";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseCategory>(method, url, params, urlParams, body, contentType);
  }

  currency() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "currency";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

    historyNewRequest(formData: RequestHistory) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "historyNewRequest";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  requestFor(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "requestFor";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public updatePost(fileName: string, requestNo: string): Observable<any> {
    console.log('updatePost : ', fileName, requestNo)
    const method: string = 'POST';
    const func: string = 'updatePost';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof fileName !== 'undefined' && fileName !== null) urlParams.fileName = fileName;
    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    console.log('urlParams', urlParams)

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body);
  }

  listDetail(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "listDetail";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  submitEmpAttendanceLeave(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "submitEmpAttendanceLeave";
    const params: any = formData || {};
    const urlParams: any = formData || {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/training/training-history-api.ts